const defaultTranslations = {
  unknown: "Unknown thing to translate",
  unauthed: "You are not authorized to see this page",
}

export default defaultTranslations
